import Service, { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { AdNetworkType, PROVIDER_MAP } from 'cio/utils/ad-audiences';
import ApiErrorsService from 'cio/services/api-errors';
import DS from 'ember-data';
import AudienceCredentialModel from 'cio/models/audience-credential';
import { NO_OAUTH_RESPONSE } from 'cio/utils/oauth';
import OAuthService from 'cio/services/oauth';
import FacebookConnectService from './facebook-connect';

export default class AudienceCredentialsService extends Service {
  @service store!: DS.Store;
  @service apiErrors!: ApiErrorsService;
  @service oauth!: OAuthService;
  @service facebookConnect!: FacebookConnectService;

  setupProviderTask = task({ drop: true }, async (type: AdNetworkType, credential?: AudienceCredentialModel) => {
    try {
      let response =
        type === 'facebook'
          ? await this.facebookConnect.login({ feature: 'ad_audiences' })
          : await this.oauth.open(PROVIDER_MAP[type]!);

      if (!credential) {
        credential = this.store.createRecord('audience-credential', { type });
      }

      credential.set('json', JSON.stringify(response));
      return await credential.save();
    } catch (err) {
      // If the user cancelled the signup process, we don't want to report an error
      // Facebook/oauth for some reason returns an error "unknown"
      if (err.message !== NO_OAUTH_RESPONSE && err !== 'unknown') {
        this.apiErrors.report(err);
      }

      throw err;
    }
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'audience-credentials': AudienceCredentialsService;
  }
}
